/* tslint:disable */
import { defineMessages } from 'react-intl';

export default defineMessages({
    starts: {
        defaultMessage:
            'Matches begin in the next {interval, plural, =30 {30 minutes} =1 {hour} other {# hours}}',
        id: 'component.CategorizerHeadingLiveControls.starts',
    },
    started: {
        defaultMessage: 'Matches that last more than {time}',
        id: 'component.CategorizerHeadingLiveControls.started',
    },
    live: {
        defaultMessage: 'All Live matches',
        id: 'component.CategorizerHeadingLiveControls.live',
    },
    allNextToGo: {
        defaultMessage: 'Matches begin in the next 24 hours',
        id: 'component.CategorizerHeadingLiveControls.allNextToGo',
    },
    all: {
        defaultMessage: 'All',
        id: 'component.Categorizer.all',
    },
    '1hour': {
        defaultMessage: 'Hour',
        id: 'component.FilterByTimePeriod.hour',
    },
    today: {
        defaultMessage: 'Today',
        id: 'component.FilterByTimePeriod.today',
    },
    yesterday: {
        defaultMessage: 'Yesterday',
        id: 'component.FilterByTimePeriod.yesterday',
    },
    '3days': {
        defaultMessage: '3 Days',
        id: 'component.FilterByTimePeriod.threeDays',
    },
    week: {
        defaultMessage: 'Week',
        id: 'component.FilterByTimePeriod.week',
    },
    tournaments: {
        defaultMessage: 'Tournaments',
        id: 'filters.SportsNavigation.tournaments',
    },
});
